import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class UserManagementRouteDefinition {
  public static getRoutes(hideInvoices: boolean): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.USERS,
      resolver: AlwaysShowRouteResolver,
      title: 'Users',
      icon: 'icon-customers.svg',
      position: 4,
      children: [
        {
          path: RoutePaths.USERS,
          parentPath: RoutePaths.USERS,
          title: 'Users',
          position: 0
        },
        {
          path: RoutePaths.GROUPS,
          parentPath: RoutePaths.USERS,
          title: 'User Groups',
          position: 1
        },
        {
          path: RoutePaths.CUSTOMERS,
          parentPath: RoutePaths.USERS,
          title: 'Customers',
          position: 2
        }
      ]
    };

    if (!hideInvoices) {
      menuItems.children.push({
        path: RoutePaths.INVOICES,
        parentPath: RoutePaths.USERS,
        title: 'Invoices',
        position: 3
      });
    }

    return menuItems;
  }
}
